module.exports = __webpack_public_path__ + "img/empty_shot.8f70da90.png";